export function getUrlWithoutQueryParams(url: string): string {
  return url.substr(0, url.indexOf('?'));
}
